<div class="header">
  <div class="icon">JV</div>
  <div class="info">
    <slot />
  </div>
</div>

<style>
  .header {
    display: flex;
    width: 100%;
    color: #aaa;
    background: black;
    gap: 16px;
    height: 55px;
  }
  .header .icon {
    font-weight: 100;
    font-size: 32px;
    padding: 6px;
    padding-left: 16px;
  }
  .header .info {
    font-weight: 200;
    padding: 16px;
    display: flex;
    flex-grow: 1;
    align-items: center;
  }
</style>
